$(document).ready(function () {
    const tzSelect = document.querySelector('#timezone');
    if (tzSelect) {
        const tz = moment.tz.guess(true);
        if (tz) {
            tzSelect.value = tz;
        }
    }

    $('body').on('change', '#how_did_you_hear', function () {
        $('#how_did_you_hear_other_field').toggleClass('d-none', $(this).val() !== 'Other');
    });

    $('body').on('change', '#organisation-industry', function () {
        $('#organisation-industry_other-field').toggleClass('d-none', $(this).val() !== 'Other');
    });

    $('body').on('change', '#dummy_control', function () {
        document.getElementById('real_control').value = this.checked ? 0 : 1;
    });
});
